import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { NewsletterResource } from 'app/models/NewsletterResource';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GdprCreateSubscribeService {

  constructor(private http: HttpClient) { }

  postCreateUserGDPR(url, body): Observable<NewsletterResource> {
   return this.http.post<NewsletterResource>(url, body)
 }
}
